import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import { IconBulb } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";
import { Dialog, DialogTrigger, Popover } from "react-aria-components";
import { SuggestionsPill } from "./suggestionsPill.js";

export interface SuggestionsWidgetProps {
  isLoading?: boolean;
  isFetching?: boolean;
  summary?: ReactNode;
  suggestions: readonly ReactNode[] | undefined;
  onRefreshClick?: () => void;
}

export const SuggestionsWidget: FC<SuggestionsWidgetProps> = (props) => {
  return (
    <DialogTrigger>
      <SuggestionsPill
        isLoading={props.isLoading}
        count={props.suggestions?.length}
      />
      {props.summary || props.suggestions?.length ? (
        <Popover className="rounded-md bg-white shadow-lg ring-1 ring-black/5 data-[entering]:animate-popover-enter data-[exiting]:animate-popover-exit">
          <Dialog className="w-96 space-y-4 px-4 py-4 text-sm">
            {props.summary ? <div>{props.summary}</div> : null}
            {props.suggestions?.length ? (
              <ul className="space-y-2">
                {props.suggestions.map((suggestion, index) => (
                  <li key={index} className="items-top flex space-x-2">
                    <IconBulb className="size-5 shrink-0 text-purple-700" />
                    <div>{suggestion}</div>
                  </li>
                ))}
              </ul>
            ) : null}
            {props.onRefreshClick ? (
              <Button
                variant={ButtonVariant.Secondary}
                size={Size.MEDIUM}
                isLoading={props.isFetching}
                isDisabled={props.isFetching}
                onClick={props.onRefreshClick}
              >
                Refresh
              </Button>
            ) : null}
          </Dialog>
        </Popover>
      ) : null}
    </DialogTrigger>
  );
};
